<app-pos-main-menu (checkSelectorChange)="onCheckChange()"></app-pos-main-menu>

<p-button pRipple styleClass="p-button-raised p-button-warning m-2 mobile-screen-check" (click)="onMobileViewCheck()">
	<ng-template pTemplate="content">
		<div class="d-flex justify-content-center">
			<fa-icon [icon]="['fad', 'bars']" size="4x"></fa-icon>
		</div>
	</ng-template>
</p-button>

<p-dialog *ngIf="viewMobileCheck" [(visible)]="viewMobileCheck" [style]="{ width: '100vw', height: '100vh' }" styleClass="animation-slide-in-top">
	<app-pos-on-screen-check (checkSelectorChange)="onCheckChange()"></app-pos-on-screen-check>
</p-dialog>

<p-dialog *ngIf="viewCheckList" [(visible)]="viewCheckList" [style]="{ width: '100vw', height: '100vh' }" styleClass="animation-slide-in-top">
	<ng-template pTemplate="Checks"></ng-template>
	<app-pos-check-list [(viewCheckList)]="viewCheckList"></app-pos-check-list>
</p-dialog>
